import { HoverCard, Stack, HoverCardProps } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { ReactNode } from 'react';
interface Props extends HoverCardProps {
    targetComponent?: ReactNode; // Optional component displayed alongside hover target
    cardTitle: string; // Customizable title
    maxHeight?: string;
    hoverTarget?: ReactNode; // Optional custom hover target to replace info icon
}

export default function CustomHoverCard({
    targetComponent,
    cardTitle,
    children,
    width = '580px',
    maxHeight,
    withArrow = true,
    withinPortal = true,
    position = 'right',
    arrowSize = 16,
    arrowOffset = 0,
    shadow = 'md',
    hoverTarget,
    ...props
}: Props) {
    return (
        <HoverCard
            width={width}
            withArrow={withArrow}
            withinPortal={withinPortal}
            position={position}
            arrowSize={arrowSize}
            arrowOffset={arrowOffset}
            shadow={shadow}
            {...props}
        >
            {hoverTarget ? (
                <HoverCard.Target>
                    <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
                        {hoverTarget}
                    </span>
                </HoverCard.Target>
            ) : (
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                    {targetComponent}
                    <HoverCard.Target>
                        <IconInfoCircle size={20} style={{ cursor: 'pointer', color: '#476DB9', flexShrink: 0 }} />
                    </HoverCard.Target>
                </div>
            )}

            <HoverCard.Dropdown className='hover-card'>
                <div>
                    {cardTitle && <div className='hover-card-title'>{cardTitle}</div>}
                    <Stack
                        align='flex-start'
                        style={maxHeight ? {
                            maxHeight,
                            overflowY: 'auto',
                            boxSizing: 'border-box'
                        } : undefined}
                    >
                        {children}
                    </Stack>
                </div>
            </HoverCard.Dropdown>
        </HoverCard>
    );
}